// extracted by mini-css-extract-plugin
export default {"spinner":"EntryPage_spinner__Tvz3P"};